const LOCALE_MAP = { te: 'te-IN', en: 'en-IN', ta: 'ta-IN', kn: 'kn-IN' };

const RELATIVE = {
  en: {
    justNow: 'Just now',
    min: (m) => `${m} min ago`,
    hr: (h) => `${h} hr ago`,
    day: (d) => `${d} day${d > 1 ? 's' : ''} ago`,
  },
  te: {
    justNow: 'ఇప్పుడే',
    min: (m) => `${m} నిమి క్రితం`,
    hr: (h) => `${h} గం క్రితం`,
    day: (d) => `${d} రోజు${d > 1 ? 'ల' : ''} క్రితం`,
  },
  ta: {
    justNow: 'இப்போது',
    min: (m) => `${m} நிமிடம் முன்`,
    hr: (h) => `${h} மணி முன்`,
    day: (d) => `${d} நாள்${d > 1 ? 'கள்' : ''} முன்`,
  },
  kn: {
    justNow: 'ಈಗಷ್ಟೇ',
    min: (m) => `${m} ನಿಮಿ ಹಿಂದೆ`,
    hr: (h) => `${h} ಗಂ ಹಿಂದೆ`,
    day: (d) => `${d} ದಿನ${d > 1 ? 'ಗಳ' : ''} ಹಿಂದೆ`,
  },
};

export function formatTimeAgo(dateInput, lang = 'te') {
  if (!dateInput) return '';
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (Number.isNaN(date.getTime())) return '';

  const sec = Math.floor((Date.now() - date.getTime()) / 1000);
  const locale = LOCALE_MAP[lang] || 'te-IN';
  const pack = RELATIVE[lang] || RELATIVE.te;

  if (sec < 60) return pack.justNow;
  if (sec < 3600) return pack.min(Math.floor(sec / 60));
  if (sec < 86400) return pack.hr(Math.floor(sec / 3600));
  if (sec < 604800) return pack.day(Math.floor(sec / 86400));

  return date.toLocaleDateString(locale, { day: 'numeric', month: 'short', year: 'numeric' });
}
